export const NotFound = () => (
  <div>
    <h2>404 - Not Found!</h2>
    <p>
      This page either does not exist or you do not have permission to view it
    </p>
  </div>
);
